import request from "@/util/request";

export function listGameType() {
    return request({
        url: '/boxGameType/list',
        method: 'get'
    })
}

export function saveOrUpdateGameType(data) {
    return request({
        url: '/boxGameType/saveOrUpdate',
        method: 'post',
        data: data
    })
}

export function deleteGameType(id) {
    return request({
        url: '/boxGameType/deleteById',
        method: 'delete',
        params: {id}
    })
}
